export const apiConfig = {
  screen:
    (process.env.KONG_API_DOMAIN || '') +
    '/h/ca-web/apigw/screens/deeplink/{deeplink}',
};
